import { useQuery } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useRouteParams } from '../hooks/useRouteParams';
import { CustomerType, IraAccountType } from '../../../ApexOPL/AccountOpening/AccountOpening.meta';

export enum AccountTypeDTO {
  LongTerm = 'LongTerm',
  Retirement = 'Retirement',
}

export enum WhoIsForOptionsDTO {
  Single = 'Single',
  Joint = 'Joint',
}

export enum AccountTypeOptionsDTO {
  TraditionalIRA = 'TraditionalIRA',
  SimpleIRA = 'SimpleIRA',
  RothIRA = 'RothIRA',
  RollOver401k = 'RollOver401k',
}

export interface LongTermDTO {
  whoIsFor: WhoIsForOptionsDTO | null;
  birthDate: string | null;
  partnerFirstName: string | null;
  partnerLastName: string | null;
  partnerBirthDate: string | null;
  totalInvestableAssets: number | null;
}

export interface RetirementDTO {
  accountType: AccountTypeOptionsDTO | null;
  simplePlanName: string | null;
  birthDate: string | null;
  totalInvestableAssets: number | null;
  howMuchSaved: number | null;
}

export interface WhatIfOptionsDTO {
  monthlyContribution: number;
  monthlyContributionMax: number;
  monthlyContributionMin: number;
  startingInvestmentMin: number;
  startingInvestment: number;
  startingInvestmentMax: number;
  yearsBeforeWithdrawal: number;
  yearsBeforeWithdrawalMax: number;
  yearsBeforeWithdrawalMin: number;
}

export interface AutomatedAccountsDTO {
  financialGoal: AccountTypeDTO;
  longTerm: LongTermDTO;
  retirement: RetirementDTO;
  whatIfOptions: WhatIfOptionsDTO;
  allowedConsumerTypes: CustomerType[];
  allowedIraAccountTypes: IraAccountType[];
}

const fetchAutomatedAccounts = async (clientId: string): Promise<AutomatedAccountsDTO> =>
  authFetch(
    urlWithParams('/Consumer/AutomatedAccounts', {
      clientId,
    }),
  );

interface UseAutomatedAccountsQueryParams {
  enabled?: boolean;
}

export const useAutomatedAccountsQuery = ({
  enabled = true,
}: UseAutomatedAccountsQueryParams = {}) => {
  const { clientId } = useRouteParams();

  return useQuery(queryKeys.automatedAccounts(clientId), () => fetchAutomatedAccounts(clientId), {
    cacheTime: 0,
    enabled,
  });
};
